export var SortType;

(function (SortType) {
  SortType[SortType["AtoZ"] = 0] = "AtoZ";
  SortType[SortType["new"] = 1] = "new";
  SortType[SortType["ZtoA"] = 2] = "ZtoA";
  SortType[SortType["ascendingPrice"] = 3] = "ascendingPrice";
  SortType[SortType["descendingPrice"] = 4] = "descendingPrice";
  SortType[SortType["loading"] = 5] = "loading";
})(SortType || (SortType = {}));

export function sort(items, sort) {
  switch (sort.type) {
    case SortType.AtoZ:
      return sortAtoZ(items, sort.getTitle);

    case SortType["new"]:
      return sortDate(items, sort.getDate);

    case SortType.ZtoA:
      return sortZtoA(items, sort.getTitle);

    case SortType.ascendingPrice:
      return sortAscendingPrice(items);

    case SortType.descendingPrice:
      return sortDescendingPrice(items);

    default:
      return items;
  }
} // TODO sortAscendingPrice

function sortAscendingPrice(items) {
  return items;
} // TODO sortDescendingPrice


function sortDescendingPrice(items) {
  return items;
}

function sortDate(items, getDate) {
  return items.sort(function (itemA, itemB) {
    var dateA = getDate(itemA);
    var dateB = getDate(itemB);

    if (isNaN(dateA.getTime())) {
      return -1;
    }

    if (isNaN(dateA.getTime())) {
      return 1;
    }

    if (dateA > dateB) {
      return -1;
    }

    if (dateA < dateB) {
      return 1;
    }

    return 0;
  });
}

function sortAtoZ(items, getTitle) {
  return items.sort(function (itemA, itemB) {
    return getTitle(itemA).localeCompare(getTitle(itemB));
  });
}

function sortZtoA(items, getTitle) {
  return items.sort(function (itemA, itemB) {
    return -getTitle(itemA).localeCompare(getTitle(itemB));
  });
}